import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { formatServiceAddress, getGroupingServiceDateRange } from '@wayste/client-utils';
import { ClipboardDocumentListIcon } from '@heroicons/react/20/solid';
import { CustomFormContext } from '../../formWrapper/SourSearchWrapper';
import { ErrorBoundary } from './helper/ErrorBoundary';
import UniversalServicesStatusPill from './helper/UniversalServicesStatusPill';
import { ResultWrapper } from './helper/resultWrapper';
export const ServiceGroupingResult = ({ grouping }) => {
    const { id, orderNumber } = grouping;
    const { onNavigate, application, onResetValues } = useContext(CustomFormContext);
    const status = grouping.serviceOrders.every((serviceOrder) => serviceOrder.cancellationDetails)
        ? 'CANCELLED'
        : grouping.serviceOrders.every((serviceOrder) => serviceOrder.status)
            ? grouping.serviceOrders[0].status
            : 'MIXED';
    const order = {
        serviceGrouping: grouping,
        status: status,
        serviceRange: getGroupingServiceDateRange(grouping).string,
        subscription: grouping.type !== 'single' ? 'Subscription' : 'One Time',
        serviceSKU: [...new Set(grouping.serviceOrders.map((serviceOrder) => serviceOrder.serviceType.family.name))].join(', '),
        address: grouping.serviceOrders.every((serviceOrder) => serviceOrder.serviceLocation)
            ? formatServiceAddress(grouping.serviceOrders[0].serviceLocation?.address)
            : 'Multiple',
        orderNumber: grouping.orderNumber,
        customer: grouping.customerCompanyName || grouping.customerName,
        vendor: grouping.serviceOrders.every((serviceOrder) => !serviceOrder.vendorName)
            ? ''
            : grouping.serviceOrders.every((serviceOrder) => serviceOrder.vendorName)
                ? grouping.serviceOrders[0].vendorName
                : 'Multiple',
    };
    const handleRedirect = () => {
        onNavigate(grouping, id, 'serviceGrouping');
        onResetValues('search');
    };
    return (_jsx(ErrorBoundary, { children: _jsxs(ResultWrapper, { onRedirect: handleRedirect, children: [_jsx(ClipboardDocumentListIcon, { className: "size-4" }), _jsx("div", { className: "border-l-2 border-gray-300 pl-2", children: orderNumber }), application !== 'customer-portal' && (_jsx("div", { className: "flex flex-col items-center justify-center overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: _jsx(UniversalServicesStatusPill, { status: status }) })), _jsx("div", { className: "overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: order.address }), _jsx("div", { className: "overflow-hidden overflow-ellipsis whitespace-nowrap border-l-2 border-gray-300 pl-2", children: order.serviceSKU })] }) }));
};
//# sourceMappingURL=ServiceGroupingResult.js.map